export class GlasContainerUI {
  constructor(glasContainerSearch) {
    this.hiddenClass = "hidden";
    this.loadingIndicator = glasContainerSearch.querySelector(".glas-container-locations__map-loading-indicator");
  }
  toggleElementVisibility(element, show) {
    if (show) {
      element.classList.remove(this.hiddenClass);
    } else {
      element.classList.add(this.hiddenClass);
    }
  }
  addClickListener(element, handler) {
    element.addEventListener("click", handler);
  }
  addSubmitListener(formElement, handler) {
    formElement.addEventListener("submit", handler);
  }
  showMessageElements(elements, show) {
    elements.forEach((element) => {
      this.toggleElementVisibility(element, show);
    });
  }
  scrollToElement(element, offset = 0) {
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: elementPosition - offset,
      behavior: "smooth"
    });
  }
  hideAndShowLoadingIndicator(loading) {
    this.loadingIndicator?.classList.toggle(this.hiddenClass, !loading);
  }
}
